import { z } from 'zod'
import { fallback } from '../../../../utilities/zod-utils'

const fallbackData = {
	content: '', // this is not used for native text (e.g. ad title etc)
	textColor: '#ffffff',
	sizeMultiplier: 1,
	fontWeight: 400,
	fontFamilyOverride: '',

	bubbleMode: 'none',
	bubbleColor: '#000000',
	bubbleOpacity: 0,
} as const

const contentSchema = z.string().or(fallback(fallbackData.content))
const textColorSchema = z.string().or(fallback(fallbackData.textColor))
const sizeMultiplierSchema = z.number().or(fallback(fallbackData.sizeMultiplier))
const fontWeightSchema = z.number().or(fallback(fallbackData.fontWeight))
const fontFamilyOverride = z.string().or(fallback(fallbackData.fontFamilyOverride))

const baseSchema = z.object({
	content: contentSchema,
	textColor: textColorSchema,
	sizeMultiplier: sizeMultiplierSchema,
	fontWeight: fontWeightSchema,
	fontFamilyOverride: fontFamilyOverride,
})

export const metaTextLayerSchema = baseSchema.or(fallback(fallbackData))

export type MetaTextLayerConfiguration = z.infer<typeof metaTextLayerSchema>

export const metaTextLayerDefault: MetaTextLayerConfiguration = metaTextLayerSchema.parse({})

export const defaultTitleTextLayerConfiguration = {
	content: '',
	textColor: '#ffffff',
	sizeMultiplier: 1.5,
	fontWeight: 600,
	fontFamilyOverride: '',
} satisfies MetaTextLayerConfiguration

export const metaDefaultTitleTextLayerSchema = baseSchema.or(fallback(defaultTitleTextLayerConfiguration))

export const defaultSubtitleTextLayerConfiguration = {
	content: '',
	textColor: '#ffffff',
	sizeMultiplier: 1.4,
	fontWeight: 400,
	fontFamilyOverride: '',
} satisfies MetaTextLayerConfiguration

export const metaDefaultSubtitleTextLayerSchema = baseSchema.or(fallback(defaultSubtitleTextLayerConfiguration))
